<template>
  <div class="adp-document-card-skeleton">
    <div class="left-content">
      <div class="m-sentences-skeleton">
        <div class="m-line1"></div>
        <div class="m-line2"></div>
        <div class="m-line3"></div>
        <div class="m-date"></div>
      </div>
      <div class="actions">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="m-image-skeleton"></div>
  </div>
</template>

<style lang="scss" scoped>
.adp-document-card-skeleton {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  padding: 16px 0;
  width: 100%;
  background: #ffffff;
  align-items: flex-start;
  margin-bottom: 1px;
  margin-top: 8px;
  border-top: 1px solid $color-gray400;

  .left-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-right: 47px;

    .m-sentences-skeleton {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: 0px;
      .m-line1,
      .m-line2,
      .m-line3,
      .m-date {
        height: 8px;
        background: $color-gray400;
        border-radius: 4px;
        margin: 6px 0;
      }
      .m-line1 {
        width: 437px;
      }
      .m-line2 {
        width: 300px;
      }
      .m-line3 {
        width: 200px;
      }
      .m-date {
        width: 56px;
      }
    }
    .actions {
      display: flex;
      gap: 32px;
      margin-top: 15px;

      div {
        background: $color-gray400;
        border-radius: 4px;
        width: 20px;
        height: 20px;
      }
    }
  }
  .m-image-skeleton {
    width: 80px;
    height: 80px;
    background: $color-gray400;
    border: 1px solid $color-gray400;
    border-radius: 4px;
    flex-shrink: 0;
  }
}
</style>
